import PagetationList from './Pagetation'
// 这里是重点
const Pagetation = {
  install: function(Vue){
    Vue.component('PagetationList',PagetationList)
  }
}

// 导出组件
export default Pagetation





// WEBPACK FOOTER //
// ./src/components/pagetation/index.js